import Vue from "vue";

Vue.component("ipcategory-tag-input", {
    props: ["label", "placeholder", "items", "list", "ids", "isReadOnly", "labelPosition", "labelCss", "excludeNone"],
    data() {
        return {
            selectItems: [],
            options: [],
            noneId: null,
        };
    },
    methods: {
        typingdisabled(text) {

        },
        getFilteredItems(text) {
            this.options = this.items.filter((option) => {
                return !this.computedValue.includes(option) && option.text.toLowerCase().indexOf(text.toLowerCase()) >= 0;
            });
        },
        getValues: function (ids) {
            const returnValue = [];
            const items = this.items;

            ids.forEach(function (id) {
                const item = items.filter((t) => { return t.value == id });
                if (item.length > 0) {
                    returnValue.push(item[0]);
                }
            });

            return returnValue;
        },
        getDataSourceMultiText: (dataSource, value) => {
            if (dataSource) {
                const items = dataSource.filter(i => value.includes(i.value));
                var returnValue = "";
                items.forEach(function (item) {

                    returnValue += `${item.text}; `;
                });
                return returnValue;
            }
            return "";
        },
        itemAdded: function () {
            this.options = this.items;
        },
        beforeAdd: function (tag) {
            let result = this.options.length > 0;
            let isSelectedTagIsNone = tag.value == this.noneId;
            let hasNoneSelected = this.computedValue.find(x => x.value == this.noneId);
            if (hasNoneSelected) result = false;
            if (isSelectedTagIsNone && this.computedValue.length > 0) result = false;
            if (!result) {
                this.itemAdded();
            }
            return result;
        },
        getNoneId: function () {
            this.$services.ipCategories.getAll({
                language: window.currentLanguageInt
            })
                .then((data) => {
                    var noneVal = data.items.find(x => x.name.toLowerCase() == 'none');
                    if (noneVal) {
                        this.noneId = noneVal.id;
                    }
                });
        }
    },
    mounted() {
        this.options = this.items;
        this.getNoneId();
    },
    watch: {
        items: function (val) {
            this.options = val;
        },
        computedValue: function (val) {
            this.options = this.items.filter((option) => {
                return !val.includes(option);
            });
        }
    },
    computed: {
        noItemMessage: function () {
            return window.labels.thereAreNoItems;
        },
        computedValue: {
            get() {
                const ids = this.ids;
                if (!ids || ids.length === 0) return [];
                const val = this.getValues(ids);
                return val;
            },
            set(value) {
                if (value) {
                    let texts = [];
                    let ids = [];
                    value.forEach(function (item) {
                        texts.push(item.text);
                        ids.push(item.value);
                    });

                    if (this.list) {
                        this.$emit("update:list", texts);
                    }

                    this.$emit("update:ids", ids);
                }
            }
        }
    },
    template: `
		<b-field :label-position="labelPosition" :label="label" :class="labelCss">
			<b-taginput v-if="!isReadOnly"  v-model="computedValue" :before-adding="beforeAdd" attached :disabled="isReadOnly" :data="options" autocomplete ref="ipcategoryTagInput" icon="label" field="text" :open-on-focus="!isReadOnly" :placeholder="placeholder" @typing="getFilteredItems" @add="itemAdded">
				<template v-slot="props"> {{props.option.text}} </template>
				<template #empty> {{ noItemMessage }} </template>
			</b-taginput>
			<b-taginput v-if="isReadOnly"  v-model="computedValue" :closable="!isReadOnly" attached :readonly="isReadOnly" :before-adding="beforeAdd" :data="options"  ref="ipcategoryTagInput" icon="label" field="text" :open-on-focus="!isReadOnly">
				<template v-slot="props"> {{props.option.text}} </template>
				<template #empty> {{ noItemMessage }} </template>
			</b-taginput>
		</b-field>
	`
});